import React, { useEffect, useState } from "react"
import { supabase } from "../../lib/supabaseClient"

export default function StickyPartnerBannerManaged({
  storageKey = "qp_sticky_closed",
  position = "bottom", // 'top' | 'bottom'
}) {
  const [ad, setAd] = useState(null)
  const [open, setOpen] = useState(true)

  useEffect(() => {
    try {
      const v = localStorage.getItem(storageKey)
      if (v === "1") setOpen(false)
    } catch {}
  }, [storageKey])

  useEffect(() => {
    let mounted = true
    ;(async () => {
      const nowIso = new Date().toISOString()
      const { data, error } = await supabase
        .from("ads")
        .select("*")
        .eq("slot", "sticky")
        .eq("enabled", true)
        .lte("starts_at", nowIso)
        .or("ends_at.is.null,ends_at.gte." + nowIso)
        .order("priority", { ascending: true })
        .order("created_at", { ascending: false })
        .limit(1)

      if (!mounted) return
      if (!error && data && data[0]) setAd(data[0])
      else setAd(null)
    })()
    return () => {
      mounted = false
    }
  }, [])

  const close = () => {
    setOpen(false)
    try {
      localStorage.setItem(storageKey, "1")
    } catch {}
  }

  if (!open || !ad) return null

  const posClass = position === "top" ? "top-0" : "bottom-0"

  return (
    <div className={`fixed ${posClass} inset-x-0 z-[120]`}>
      <div className="mx-auto max-w-7xl px-4 py-2">
        <div className="rounded-xl shadow-lg bg-gradient-to-r from-indigo-600 to-sky-600 text-white flex items-center justify-between gap-3 px-4 py-3">
          <div className="flex items-center gap-3">
            {ad.image_url ? (
              <img
                src={ad.image_url}
                alt={ad.title || "Publicidad"}
                className="w-10 h-10 rounded-lg object-cover hidden sm:block"
              />
            ) : null}
            <div className="text-sm md:text-base font-medium">
              {ad.title || "Publicidad"}
            </div>
          </div>
          <div className="flex items-center gap-2">
            {ad.href ? (
              <a
                href="https://panel.quipusmania.com/signin"
                target="_blank"
                rel="noreferrer noopener"
                className="bg-white text-indigo-700 font-semibold px-3 py-1.5 rounded-lg hover:opacity-90 text-sm"
              >
                Afiliar
              </a>
            ) : null}
            <button
              onClick={close}
              className="text-white/90 hover:text-white text-xl leading-none px-2"
              aria-label="Cerrar"
            >
              ×
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
